"use client"

import { useUser } from "lib/user"

export const useQuizLink = (): {
  showQuizLink: boolean
} => {
  const { hasClickedQuizLink } = useUser()

  return {
    showQuizLink: !hasClickedQuizLink,
  }
}
